import {Component, Input} from '@angular/core';
import {selectDetailPageProposal, selectDetailPageProposalTile} from '../../../../store/proposal/selectors/proposal.selectors';
import {Router} from '@angular/router';
import {UserService} from '../../../../services/user/user.service';
import {Store} from '@ngrx/store';
import {ProposalAppState} from '../../../../store/proposal/reducers/proposal.reducer';
import {Route} from '../../../../enum/route';
import {getCurrencySymbol} from '@angular/common';
import {Subject, takeUntil} from 'rxjs';

@Component({
    selector: 'app-create-offer-information',
    templateUrl: './create-offer-information.component.html',
    styleUrls: ['./create-offer-information.component.scss'],
    standalone: false
})
export class CreateOfferInformationComponent {

  @Input() isExternalCoverage: boolean = false;

  allDetailsOpen: boolean = false;
  proposal$ = this.proposalStore.select(selectDetailPageProposal);

  proposalTile$ = this.proposalStore.select(selectDetailPageProposalTile);
  Route = Route;

  protected destroy$ = new Subject<void>();

  constructor(private readonly router: Router,
              readonly userService: UserService,
              public readonly proposalStore: Store<ProposalAppState>,
  ) {
  }

  ngOnDestroy() {
    this.destroy$.next();
  }

  currencySymbol(currency) {
    return getCurrencySymbol(currency, 'narrow');
  }

  coverageColor(coverage) {
    if (coverage < 1 / 3) {
      return '#AB1400';
    } else if (coverage < 2 / 3) {
      return '#946300';
    } else {
      return '#4D9407';
    }
  }

  navigateToUserProfile() {
    this.proposal$.pipe(takeUntil(this.destroy$)).subscribe((proposal) => {
      this.router.navigate([Route.USER_PAGE, proposal.creator.id]).then();
    });

  }
}
